// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/workflow-page/workflow-page.scss
// module id = 5228
// module chunks = 50